import { render, staticRenderFns } from "./InstallationHistoryTab.vue?vue&type=template&id=dc6cd7c2&scoped=true"
import script from "./InstallationHistoryTab.vue?vue&type=script&lang=js"
export * from "./InstallationHistoryTab.vue?vue&type=script&lang=js"
import style0 from "./InstallationHistoryTab.scss?vue&type=style&index=0&id=dc6cd7c2&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc6cd7c2",
  null
  
)

export default component.exports